import React, { useState, useMemo, useCallback } from 'react';
import { Link, withRouter } from 'react-router-dom';

import Traductor from '../../../Traductor';
import '../../../../css/components/auctions/AuctionCard.css';
import {
    isAppleDeviceOrNavegatorForDates,
    formatDate,
    getImageSource,
} from '../../../../Functions';
import Globals from '../../../../Globals';
import { formatNumber } from '../../../../js/components/shared/vehicleFunctions';

import CardHeader from './CardHeader';
import CardBody from './CardBody';
import useServerTime from './../../../../hooks/useServerTime';

const BatchCard = ({
    loading,
    CreateDate,
    EndDate,
    ImageSource,
    Name,
    DescStatus,
    NumVehicles,
    Amount,
    Id,
    IdStatus,
    history,
}) => {
    const t = new Traductor();
    const [auctionEnd, setAuctionEnd] = useState(false);
    const { serverTime } = useServerTime(true);

    const onNavigateToBatchDetails = useCallback(() => {
        //Persist batch details in case user refreshes the page in details screen and navigation state is lost

        localStorage.setItem(
            'selectedBatchDetails',
            JSON.stringify({
                Id,
                Name,
                DescStatus,
                IdStatus,
                CreateDate,
                EndDate,
                Amount,
                NumVehicles,
            })
        );
    }, [
        Amount,
        CreateDate,
        EndDate,
        NumVehicles,
        Name,
        DescStatus,
        IdStatus,
        Id,
    ]);

    return (
        <article
            className={`c-card c-card--auction ${
                loading ? 'skeleton' : ''
            } u-mv u-p ${auctionEnd ? 'u-bg-pale' : ''}`}
            onClick={() => {
                if (!Id) return;
                onNavigateToBatchDetails();
                history.push({
                    pathname: `${Globals.APPLICATION_PATH.BATCHES}/${Id}`,
                    state: {
                        batch: {
                            Id,
                            Name,
                            DescStatus,
                            CreateDate,
                            EndDate,
                            Amount,
                            NumVehicles,
                            IdStatus,
                        },
                    },
                });
            }}
        >
            <CardHeader
                src={getImageSource(ImageSource)}
                title={Name}
                date={EndDate}
                onFinishDate={setAuctionEnd}
                disabled={auctionEnd}
                serverTime={serverTime}
            />
            <CardBody
                loading={loading}
                info={[
                    [
                        t.getTraduction('Estado'),
                        t.getTraduction('ManagementFiltersStatus')[IdStatus],
                    ],
                    [
                        t.getTraduction('CreationDate'),
                        formatDate(
                            isAppleDeviceOrNavegatorForDates(CreateDate),
                            false
                        ),
                    ],
                    [t.getTraduction('NumVehiculos'), NumVehicles],
                    [
                        `${t.getTraduction('Total')} ${t.getTraduction(
                            'Import'
                        )}`,
                        formatNumber(Amount || 0) + '€', //fallback in case is loading/null
                    ],
                ]}
                idStatus={IdStatus}
                amount={Amount}
            />
            {Id && (
                <footer className="c-card__footer u-ph-none u-pv">
                    <Link
                        className="c-btn  c-btn--link  c-btn--small"
                        to={{
                            pathname: `${Globals.APPLICATION_PATH.BATCHES}/${Id}`,
                            state: {
                                batch: {
                                    Id,
                                    Name,
                                    DescStatus,
                                    CreateDate,
                                    EndDate,
                                    Amount,
                                    NumVehicles,
                                    IdStatus,
                                },
                            },
                        }}
                        onClick={onNavigateToBatchDetails}
                    >
                        <i className="c-btn__icon c-icon  c-icon--[semantic-forward]" />
                        <span className="c-btn__text">
                            {t.getTraduction('Details')}
                        </span>
                    </Link>
                </footer>
            )}
        </article>
    );
};

export default withRouter(BatchCard);
